const merge = require('lodash/merge');
const { apiPortfolioId } = require('../../utils');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');

function getQS(parsedMetaData) {
  return {
    userId: parsedMetaData.qs.userId,
    branchCode: parsedMetaData.portfolio.branchCode
  };
}

function apiFactory({
  baseUrl,
  requestHandler,
}) {
  const headers = {
    Accept: 'application/json',
  };

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {
    getAdviceItems(fromDate, toDate, pfId, outputType, metaData) {
      const url = getUrl('reports-overview');
      const parsedMetaData = parseRequestMetaData(metaData);
        const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true,
      };

      const body = merge(getQS(parsedMetaData), {
        fromDate: fromDate,
        toDate: toDate,
        pfId: parsedMetaData.portfolio.pfRelId,
        statementType: outputType,
      });

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    },

    getAdviceItemList(fromDate, toDate, pfId, outputType, metaData) {
      const url = getUrl('reports-details');
      const parsedMetaData = parseRequestMetaData(metaData);
        const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true,
      };

      const body = merge(getQS(parsedMetaData), {
        fromDate: fromDate,
        toDate: toDate,
        pfId: parsedMetaData.portfolio.pfRelId,
        statementType: outputType,
      });

      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    },

    getPdfStatement (accountId, docId, metaData) {
      const url = getUrl('view-pdf');
      const parsedMetaData = parseRequestMetaData(metaData);
        const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true,
      };

      const body = {acnum:accountId, docId: docId,branchCode: parsedMetaData.portfolio.branchCode};
      return requestHandler(merge(reqOpts, {
        url,
        body
      }));
    },
  }
}

module.exports = apiFactory;
